import React from "react";
import { FormattedMessage } from "react-intl";

import styles from "../../src/styles/gavinyuetest.css";
import messages from "../lang/default-messages";

export default class Gavinyuetest extends React.Component {
  render() {
    return (
      <div className={styles.someStyle}>
        <FormattedMessage {...messages.editMe} />
      </div>
    );
  }
}

Gavinyuetest.displayName = "Gavinyuetest";

Gavinyuetest.propTypes = { };

Gavinyuetest.defaultProps = { };



// WEBPACK FOOTER //
// ./src/components/gavinyuetest.jsx